/* istanbul ignore file */
import React from 'react';
import {
  REQUEST_STATUS,
  REQUEST_STATUS_ALIAS,
} from 'domain/sales/opportunity/presale/request/shared/presaleRequestConstants';
import { Badge } from 'framework/ui/mui-builder';
import { useShowContext } from 'framework/show';
import { ChipOwnProps } from '@mui/material';

const PresaleStatusBadge = ({ statusSource }: { statusSource: string }) => {
  const { data } = useShowContext();

  const status = data.getValueBySource(statusSource);

  const getColor = (statusData: string): ChipOwnProps['color'] => {
    switch (statusData) {
      case REQUEST_STATUS.SUBMITTED:
        return 'info';
      case REQUEST_STATUS.COMPLETED:
        return 'success';
      default:
        return 'default';
    }
  };

  const getDisplayName = (statusData: string) => {
    return REQUEST_STATUS_ALIAS[statusData];
  };

  return <Badge color={getColor(status)}>{getDisplayName(status)}</Badge>;
};

export default PresaleStatusBadge;
